export function formatAED(value) {
    if (value == null || value === '') return '—';
    const n = Number(value);
    if (Number.isNaN(n)) return String(value);
    if (n >= 1_000_000) return `AED ${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
    if (n >= 1_000) return `AED ${(n / 1_000).toFixed(0)}K`;
    return `AED ${n.toLocaleString()}`;
}

export function formatPhone(phone) {
    if (!phone) return '';
    return phone.replace(/(\+\d{3})(\d{2})(\d{3})(\d+)/, '$1 $2 $3 $4');
}

export function initials(name) {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/);
    return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
}

export function relativeTime(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
}

export function formatDate(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleString(undefined, { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
}

export function todayStartISO() {
    const d = new Date(); d.setHours(0, 0, 0, 0); return d.toISOString();
}
export function todayEndISO() {
    const d = new Date(); d.setHours(23, 59, 59, 999); return d.toISOString();
}
export function weekEndISO() {
    const d = new Date(); d.setDate(d.getDate() + 7); d.setHours(23, 59, 59, 999); return d.toISOString();
}
export function in60DaysISO() {
    const d = new Date(); d.setDate(d.getDate() + 60); return d.toISOString().slice(0, 10);
}
export function tomorrow9amISO() {
    const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); return d.toISOString();
}
